import axios from 'axios';

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('__token__');

var api_url = 'http://ws-api.echobazar.xyz/api'

if (process.env.NODE_ENV === 'production') {
  api_url = 'https://washup-chandgaon-backend.laundryshelf.com/api'
}

export default axios.create({
  baseURL: api_url,
  headers: {'Access-Control-Allow-Origin': '*'}
});